(function() {
  if (window.POPOSOAPStartHere && window.POPOSOAPStartHere.ready) {
    return;
  }

  window.POPOSOAPStartHere = window.POPOSOAPStartHere || {};
  window.POPOSOAPStartHere.ready = true;

  function initSection(section) {
    if (!section || section.dataset.psh6Ready === 'true') {
      return;
    }

    section.dataset.psh6Ready = 'true';
    section.classList.add('is-ready');

    var revealItems = section.querySelectorAll('.psh6-reveal');

    if (!('IntersectionObserver' in window) || !revealItems.length) {
      revealItems.forEach(function(item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.12
    });

    revealItems.forEach(function(item) {
      observer.observe(item);
    });
  }

  function initAll() {
    document.querySelectorAll('.psh6-section').forEach(initSection);
  }

  document.addEventListener('click', function(event) {
    var link = event.target.closest('[data-psh6-scroll]');

    if (!link) {
      return;
    }

    var href = link.getAttribute('href');

    if (!href || href.charAt(0) !== '#') {
      return;
    }

    var target = document.querySelector(href);

    if (!target) {
      return;
    }

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
